import { debounce } from '@cian/newbuilding-utils';

const FILTER_CHANGE_TRACKING_DEBOUNCE_DELAY = 150;

export function debounceTracking<Fn extends (...args: unknown[]) => void>(trackingFn: Fn): ReturnType<typeof debounce> {
  return debounce(FILTER_CHANGE_TRACKING_DEBOUNCE_DELAY, trackingFn);
}
